import axios from 'axios';
import { API, GENERAL } from '../constants';
import { models } from '../types';

export const instance = axios.create({
    baseURL: GENERAL.API_HOSTNAME,
});

instance.interceptors.response.use(
    response => response,
    error => {
        if (!error.response.ok) {
            const message = error.response.data.message || GENERAL.API_ERROR;
            throw new Error(message);
        }
        return error;
    }
)

export const getDictionary = () => instance.get(API.DICTIONARY);

export const getSchools = (model: models.TSchools) => {
    let parameters = '';
    if (model.page) {
        const page = `page=${model.page}`;
        parameters = parameters ? `${parameters}&${page}` : page;
    }
    if (model.city) {
        const city = `city=${model.city}`;
        parameters = parameters ? `${parameters}&${city}` : city;
    }
    if (model.street) {
        const street = `street=${model.street}`;
        parameters = parameters ? `${parameters}&${street}` : street;
    }
    if (model.zipCode) {
        const zipCode = `zipCode=${model.zipCode}`;
        parameters = parameters ? `${parameters}&${zipCode}` : zipCode;
    }
    const API_URL = API.SCHOOLS + (parameters ? `?${parameters}` : '');
    return instance.get(API_URL);
};

export const getProgram = (model: models.TProgram) => {
    const API_URL = API.PROGRAM.replace(':schoolLevel', model.schoolLevel);
    return instance.get(API_URL);
};

export const getSubject = (model: models.TSubject) => {
    const API_URL = API.SUBJECT.replace(':programId', model.programId);
    return instance.get(API_URL);
};

export const postParticipant = (model: models.TParticipant) => instance.post(API.PARTICIPANT, model);
